// generated by genversion
module.exports = '2.2.5'



// WEBPACK FOOTER //
// ./version.js